@if (isMobile()) {
  <app-header-mobile
    [headerLogo]="headerLogo()"
    [headerTheme]="headerTheme()"
    [servedEnvironment]="servedEnvironment"
    [dealerIdForm]="dealerIdForm"
    [firebaseUser]="firebaseUser()"
    [currentDealer]="currentDealer()"
    [userDealers]="userDealers()"
    [displayName]="displayName()"
    [newSite]="newSite()"
    [enableFeedback]="enableFeedback && newSite()"
    (openFeedback)="onOpenFeedback()"
    (newDefaultDealerId)="newDefaultDealerId$.next($event)"
  ></app-header-mobile>
} @else {
  <app-header-desktop
    [headerLogo]="headerLogo()"
    [headerTheme]="headerTheme()"
    [servedEnvironment]="servedEnvironment"
    [enableDealerReports]="enableDealerReports"
    [dealerIdForm]="dealerIdForm"
    [firebaseUser]="firebaseUser()"
    [currentDealer]="currentDealer()"
    [userDealers]="userDealers()"
    [displayName]="displayName()"
    [newSite]="newSite()"
    [moduleGroups]="moduleGroups()"
    [enableFeedback]="enableFeedback && newSite()"
    (openFeedback)="onOpenFeedback()"
    (newDefaultDealerId)="newDefaultDealerId$.next($event)"
  ></app-header-desktop>
}
